import { baseBUCGet } from '../base/baseBUC';

const str = '';
const int = 0;

export const condominiumBoardRoleModelGet = ({ buildingId = '', userId = '', }) => {
    return {
        description: str,
        remark: str,
        hierarchy: int,
        ...baseBUCGet({ buildingId: buildingId, userId: userId, }),
    }
};